import React from 'react';
import { VerticalForm, FormInput } from '../../components/';
import { Modal, Button, Spinner } from 'react-bootstrap';

const AddMasterModal = ({
    t,
    title,
    showModal,
    closeModalWithHeaderClass,
    onSubmit,
    schemaResolver,
    extraField,
    stationName = [],
    vendor = [],
    loader,
    varient,
}) => {
    return (
        <Modal show={showModal} size="xs" onHide={closeModalWithHeaderClass}>
            <Modal.Header closeButton className="modal-colored-header">
                <h4 className="modal-title text-black">{t(title)}</h4>
            </Modal.Header>

            <Modal.Body>
                <VerticalForm onSubmit={onSubmit} resolver={schemaResolver}>
                    {/* Extra field from parent */}
                    {extraField && (
                        <FormInput
                            label={t(extraField.label)}
                            type={extraField.type}
                            name={extraField.name}
                            placeholder={t(extraField.placeholder)}
                            containerClass="mb-3"
                            onInput={extraField.onInput}
                        />
                    )}

                    <FormInput
                        label={t('Asset Type Code')}
                        type="text"
                        name="assetTypeCode"
                        placeholder={t('Enter asset type code')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Asset Type ID')}
                        type="text"
                        name="assetTypeId"
                        placeholder={t('Enter asset type id')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('SMMS Asset Code')}
                        type="text"
                        name="smmsAssetCode"
                        placeholder={t('Enter smms asset code')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('SMMS Asset Name')}
                        type="text"
                        name="smmsAssetName"
                        placeholder={t('Enter smms asset name')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Asset Number Code')}
                        type="text"
                        name="assetNumberCode"
                        placeholder={t('Enter asset number code')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Asset Number ID')}
                        type="text"
                        name="assetNumberId"
                        placeholder={t('Enter asset number id')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Parameter Type ID')}
                        type="text"
                        name="parameterTypeId"
                        placeholder={t('Enter parameter type id')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Device ID')}
                        type="text"
                        name="deviceId"
                        placeholder={t('Enter device id')}
                        containerClass="mb-3"
                    />

                    <FormInput
                        label={t('Channel Number')}
                        type="text"
                        name="channel"
                        placeholder={t('Enter channel number')}
                        containerClass="mb-3"
                        onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ''))}
                    />

                    {/* Select Fields */}
                    <FormInput type="select" label={t('Type')} name="type" containerClass="mb-3">
                        <option value="">{t('Select type')}</option>
                        <option value="current">{t('Current')}</option>
                        <option value="voltage">{t('Voltage')}</option>
                    </FormInput>

                    <FormInput type="select" label={t('Station Name')} name="stationId" containerClass="mb-3">
                        <option value="">{t('Select station name')}</option>
                        {stationName.map((item, idx) => (
                            <option key={idx} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </FormInput>

                    <FormInput type="select" label={t('Vendor')} name="vendorId" containerClass="mb-3">
                        <option value="">{t('Select vendor')}</option>
                        {vendor.map((item, idx) => (
                            <option key={idx} value={item.id}>
                                {item.vendor_cloud_name}
                            </option>
                        ))}
                    </FormInput>

                    {/* Footer */}
                    <Modal.Footer className="d-flex justify-content-end">
                        <Button
                            type="submit"
                            className="btn btn-submit"
                            style={{
                                backgroundColor: '#F9B74C',
                                fontFamily: 'Poppins, sans-serif',
                                width: '200px',
                                borderRadius: '0%',
                                border: 'none',
                            }}
                            disabled={loader}>
                            {loader ? (
                                <>
                                    <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                    {t(' Loading')}
                                </>
                            ) : (
                                <>
                                    <i className="mdi mdi-login"></i>
                                    {t('Submit')}
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </VerticalForm>
            </Modal.Body>
        </Modal>
    );
};

export default AddMasterModal;
